import React, {useEffect} from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Textarea,
  ModalFooter,
  Button,
} from "@chakra-ui/react";

const SMSCampaignModal = ({
  isOpen,
  onClose,
  onAddCampaignOpen,
  toast,
  textAreaRef,
  customizedTemplate,
  setCustomizedTemplate,
  campaignCategory,
  setIsConfigVisible,
  handleFocus,
  handleBlur,
  resetData,
  isEditing,
  setIsEditing,
  campaignType,
  saveCampaign
}) => {
  useEffect(() => {
      if (isOpen && campaignType === 'reminder') {
        if (campaignCategory === 'Confirmation'){
          setCustomizedTemplate((prevTemplate) => ({
            ...prevTemplate,
            template: {
              ...prevTemplate.template,
              sms: {
                ...prevTemplate.template.sms,
                template: prevTemplate.template.sms.template + ' {{.ConfirmationLink}}',
              },
            },
          }));
        }
      }
    }, [isOpen, campaignCategory, setCustomizedTemplate]);
  return (
    <Modal zIndex="1400" isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} blockScrollOnMount={false} // Add this line
      trapFocus={false}>
      <ModalOverlay />
      <ModalContent maxWidth="600px">  {/* Set the width here */}
        <ModalHeader>Text Message Content</ModalHeader>
        <ModalCloseButton
          onClick={() => {
            onClose();
            resetData();
          }}
        />
        <ModalBody>
          <FormControl>
            <FormLabel>Message Template</FormLabel>
            <Textarea
              name="smsTemplate"
              ref={textAreaRef}
              value={customizedTemplate?.template?.sms?.template}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    sms: {
                      ...customizedTemplate.template.sms,
                      template: e.target.value,
                    },
                  },
                });
              }}
              onFocus={() => handleFocus(["template", "sms", "template"])}
              onBlur={handleBlur}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Opt Out Template</FormLabel>
            <Textarea
              placeholder='Enter your message here otherwise "Reply U to unsubscribe" will be used as a default'
              value={customizedTemplate?.template?.sms?.opt_out}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    sms: {
                      ...customizedTemplate.template.sms,
                      opt_out: e.target.value,
                    },
                  },
                });
              }}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              if (!isEditing) {
                onAddCampaignOpen();
              } else {
                setIsEditing(false);
              }
            }}
          >
            Back
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={async () => {
              if (!customizedTemplate.template.sms?.template) {
                toast({
                  title: "Error",
                  description: "The message template cannot be empty.",
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
                return;
              }
              onClose();
              setIsConfigVisible(true);
              if (!isEditing) {
                setIsConfigVisible(true);
              } else {
                await saveCampaign();
                setIsEditing(false);
              }
            }}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SMSCampaignModal;
